import { Component, Input, Injector, inject } from "@angular/core";
import { OrgIndividualTeamsComponent } from "../../org-individual-teams.component";
import { DirectoryViewComponent } from "./../directory-view.component";
import { CommonDataService } from "./../../../common-data.service";
import { environment } from "./../../../../../environments/environment";

@Component({
  selector: "app-member-side-bar",
  templateUrl: "./member-side-bar.component.html",
  styleUrls: ["./member-side-bar.component.scss"],
})
export class MemberSideBarComponent {
  injectedCompo;
  directoryViewComponent;
  sortType: string = "asc";

  constructor(
    public injector: Injector,
    private commonService: CommonDataService
  ) {
    this.injectedCompo = this.injector.get(OrgIndividualTeamsComponent);
    this.directoryViewComponent = this.injector.get(DirectoryViewComponent);
  }

  getSortedData(sortBy: string, sortType: string) {
    this.sortType = sortType;
    let sortData: any = this.commonService.sortData(
      `${environment.profileURL}/api/v1/teams/` +
        this.injectedCompo.memViewTeam.id +
        `/memberships.json?page=${this.injectedCompo?.currentPg}&per_page=${this.injectedCompo?.teamsPerPage}&`,
      sortBy,
      sortType
    );
    sortData.subscribe((res: any) => {
      this.injectedCompo.memViewTeam.memberships = res?.memberships;
      console.log("result", res);
    });
  }

  viewChange() {
    this.directoryViewComponent.view = "dirView";
    this.injectedCompo.gridHirView = "dirView";
    this.injectedCompo.teamSrchName = ''
    this.injectedCompo.getTeamsData()
  }

}
